module.exports = __webpack_public_path__ + "assets/assets/images/about/header-illustration.6d546da7.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/about/header-illustration.png
// module id = 544
// module chunks = 0